// Remembers the last result, so a re-render with the same inputs skips the work
export const memoizeLast = <A extends any[], R>(fn: (...args: A) => R): ((...args: A) => R) => {
  let lastArgs: A | null = null;
  let lastResult: R;
  return (...args: A): R => {
    const previous = lastArgs;
    if (previous === null || previous.length !== args.length || args.some((arg, i) => arg !== previous[i])) {
      lastResult = fn(...args);
      lastArgs = args;
    }
    return lastResult;
  };
};



// WEBPACK FOOTER //
// ./src/helpers/memoizeLast.ts